export default {
    "ins_1": "Уважаемый клиент, для получения денег на карту следуйте следующей инструкции:",
    "ins_1_1": "Введите ваш Лицевой счет и Дату рождения",
    "ins_2": "Лицевой счет вы можете узнать из документа «Способы погашения микрозаймов через Партнеров» либо у своего Специалиста в М Булак",
    "ins_3": "Если введенные вами данные верны, нажмите «Далее»",
    "warn": "ВНИМАНИЕ!",
    "warn_1": "Если в сообщении указаны не ваши ФИО, свяжитесь со своим Специалистом в М Булак.",
    "warn_2": "Если вы открыли это сообщение по ошибке, игнорируйте его и не вводите никакие данные.",
    "warn_3": "Если вы строго следовали инструкции и все ввели правильно, но не получили Код на свой номер телефона, свяжитесь со своим Специалистом в М Булак.",
    "warn_4": "Если вы все сделали правильно и до конца выполнили условия инструкции, для подтверждения правильности введенных вами данных с указанной вами карты будет списан 1 рубль. В течение 10 минут после подтверждения операции 1 рубль будет возвращен на вашу карту.",
    "birthday": "Введите дату рождения",
    "account": "Лицевой счет",
    "digit_range": "От 2 до 5 цифр",
    "next": "Далее",
    "field_required": "Заполните это поле",
    "operation_failure": "Операция завершена не успешно",
    "processing": "Идет процесс",
    "continue": "Продолжить",
    "enter_code": "Введите код",
    "page_not_found": "Страница не найдена",
    "my_docs": "Мои документы",
    "close": "Закрыть",
    "credit_card": {
        "card_number": "Номер карты",
        "card_expiration_date": "Срок действия",
        "check": "Проверить",
        "submit": "Подтвердить",
    },
    "repay": {
        "h3": "Внимание:",
        "h4_title": "Внимание:",
        "h4_subtitle": "Оплата проводится только с помощью банковских карт Российской Федерации.",
        "h4_subtitle_1": "Платеж зачисляется не сразу, оплачивайте заранее: за 2-3 дня до даты в графике.",
        "h4_subtitle_2": "М Булак не взимает комиссию за платежи. Любая комиссия – это комиссия вашего банка.",
        "h4_subtitle_3": "Также, напоминаем, что платеж не поступает моментально и может обрабатываться банком несколько дней.",
        "h4_subtitle_4": "Во избежание  просроченных платежей, оплачивайте заранее.",
        "birthday": "Дата рождения",
        "account": "Лицевой счет",
        "amount": "Сумма платежа",
        "to_main_site": "На главную страницу",
        "check": "Проверка",
        "loans": "Займы",
        "payment": "Оплата",
        "forgot": "Забыли?",
        "title": "Онлайн погашение займа",
        "modal": {
            "header": "Как узнать свой лицевой счет?",
            "p1": "Если вы забыли свой лицевой счет, то отправьте с мобильного телефона, зарегистрированного в Компании, СМС* со словом «info» на номер 8(903) 76-76-000, вам придёт СМС с номером лицевого счета.",
            "p2": "Также при выдаче займа и внесении погашения на ваш номер мобильного телефона, зарегистрированного в Компании, отправляется сообщение с указанием лицевого счета. «L/chet:XX»",
            "p3": "*Стоимость СМС-сообщения определяется согласно тарифному плану Вашего оператора."
        }
    },
    "user_docs": {
        "attach": "Прикрепить",
        "processing": "Документ находится на стадии обработки",
        "page": "Страница {0} из {1}",
        "warning": "ВНИМАНИЕ! Перед прикреплением документов необходимо проверить, чтобы все фотографии документов были без размывов, хорошо читаемыми, без бликов и затемнений! При несоответствии копий документов требованиям качества - они не будут приняты."
    },
    "error_unexpected": "Произошла непредвиденная ошибка",
    "doc_view": {
        "null": "Данные не актуальны"
    },
    "choose_loan": "Выберите договор, по которому вы хотите заплатить",
    "wrong_amount": "Укажите сумму не более чем 150 000 рублей"
};

export const validation = {
    required: "Это обязательное поле",
    numeric: "Значение поля должно быть числовым",
    positive: "Значение поля должно быть положительным",
    alpha: "Значение поля должно быть буквенным",
    invalid_email: "Неправильный формат адреса электронной почты",
    card_number: "Неправильный формат номера карты",
    invalid_date: "Неправильная дата",
    card_expired: "Срок действия карты истек",
    file_size: "Размер файла {0} превышает разрешенный лимит, {1}мб",
    file_type: "Неправильный тип файла {0}, выберите один из этих: {1}",
    client_account: "Лицевой счет должен содержать от 2 до 5 цифр",
    repay_amount: "Сумма платежа должна быть от 36 до 1,000,000 руб.",
    char_length: "Длина поля должна быть {0}",
    char_length_within: "Длина поля должна быть меньше {0} и больше {1}",
};
